// Mobile Configuration for Dashboard-All
export const mobileConfig = {
  // Breakpoints
  breakpoints: {
    mobile: 768,
    tablet: 992,
    desktop: 1200,
  },

  // Chart configurations for mobile
  charts: {
    mobile: {
      height: 350,
      fontSize: {
        labels: '12px',
        legend: '12px',
        tooltip: '0.9rem',
      },
      spacing: {
        margin: '1rem',
        padding: '0.5rem',
      },
    },
    desktop: {
      height: 300,
      fontSize: {
        labels: '16px',
        legend: '14px',
        tooltip: '1rem',
      },
      spacing: {
        margin: '0.5rem',
        padding: '0.25rem',
      },
    },
  },

  // Layout configurations for mobile
  layout: {
    mobile: {
      containerPadding: '0.5rem',
      cardMargin: '1rem',
      rowMargin: '0.5rem',
      colPadding: '0.5rem',
    },
    desktop: {
      containerPadding: '1rem',
      cardMargin: '0.5rem',
      rowMargin: '0.25rem',
      colPadding: '0.25rem',
    },
  },

  // Touch target sizes for mobile
  touchTargets: {
    minHeight: '44px',
    minWidth: '44px',
    spacing: '0.5rem',
  },

  // Progressive loading thresholds
  progressiveLoading: {
    mobile: {
      maxDays: 7, // Use progressive loading only for ranges > 7 days on mobile
      showModal: false, // Don't show modal on mobile
    },
    desktop: {
      maxDays: 15, // Use progressive loading for ranges > 15 days on desktop
      showModal: true, // Show modal on desktop for large ranges
    },
  },
}

// Helper function to get current device type
export const getDeviceType = () => {
  const width = window.innerWidth
  if (width <= mobileConfig.breakpoints.mobile) return 'mobile'
  if (width <= mobileConfig.breakpoints.tablet) return 'tablet'
  return 'desktop'
}

// Helper function to get configuration for current device
export const getCurrentConfig = () => {
  const deviceType = getDeviceType()
  if (deviceType === 'mobile') {
    return {
      charts: mobileConfig.charts.mobile,
      layout: mobileConfig.layout.mobile,
      progressiveLoading: mobileConfig.progressiveLoading.mobile,
    }
  }
  return {
    charts: mobileConfig.charts.desktop,
    layout: mobileConfig.layout.desktop,
    progressiveLoading: mobileConfig.progressiveLoading.desktop,
  }
}

// Helper function to check if device is mobile
export const isMobileDevice = () => {
  const deviceType = getDeviceType()
  return deviceType === 'mobile'
}

// Helper function to check if device supports touch
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}
